import { render, staticRenderFns } from "./GenericContentDuplicationModal.vue?vue&type=template&id=8fbd637c&scoped=true"
import script from "./GenericContentDuplicationModal.vue?vue&type=script&lang=js"
export * from "./GenericContentDuplicationModal.vue?vue&type=script&lang=js"
import style0 from "./GenericContentDuplicationModal.vue?vue&type=style&index=0&id=8fbd637c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbd637c",
  null
  
)

export default component.exports